import { TError, TProDirectoryRevision } from '@onesource/schemas';
import { useQuery } from '@tanstack/react-query';

import axios from '../axios';
import { TEACHER_DIRECTORY_PATH } from './entity';

export const getProDirectoryPendingRevisionQueryKey = () => ['pro-directory', 'pending-revision'];

export const useGetProDirectoryPendingRevisionQuery = (enabled = true) => {
  return useQuery<TProDirectoryRevision | null, TError>({
    queryKey: getProDirectoryPendingRevisionQueryKey(),
    queryFn: async () => {
      const res = await axios.get<TProDirectoryRevision | null>(`/${TEACHER_DIRECTORY_PATH}/pending-revision`);
      return res.data ?? null;
    },
    enabled,
    staleTime: 0,
    refetchOnWindowFocus: false,
  });
};
